import styled from '@emotion/styled';
import { Grid } from 'atupri-component-library/lib/helpers';

export const StyledWrapper = styled(Grid)`
    display: flex;
`;
